export function normalizeNumber(
  value: string | number | null | undefined,
  min = 0,
  max = 2147483647
): number {
  if (value === null || value === undefined || value === "") return min;

  let num = Number(value);

  if (isNaN(num)) return min;

  if (num < min) return min;
  if (num > max) return max;

  return num;
}
